import React, { useEffect, useState, useContext } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import Logo from "../../images/vtc-logo.png";
import user from "../../images/user.jpg";
import banner from "../../images/broker-banner.jpg";
import Footer from "../../components/Footer/Footer";
import Skeleton from "@material-ui/lab/Skeleton";
import { APIURL, APIPath } from "../../CommonMethods/Fetch";
import { postRecord } from "../../CommonMethods/Save";
import { AuthContext } from "../../CommonMethods/Authentication";
import Footer1 from "../../components/Footer/Footer1";
import Title from "../../CommonMethods/Title";
import { MetaInfo } from "../../CommonMethods/MetaTagsContext";
const APIGetSiteSetting = APIURL() + "sitesetting";
const APIGetExampleData = APIURL() + "examplecontent";
const APIGetUserData = APIURL() + "user-details";
const APIGetBrokerDetails = APIURL() + "get-BrokerDetails";
export default function Example() {
  const { dispatch } = useContext(AuthContext);
  const context = useContext(AuthContext);
  const [currentUser, setCurrentUser] = useState({});
  const [data, setData] = useState({});
  const [exampleData, setExampleData] = useState({});
  const [currentBroker, setCurrentBroker] = useState({});
  useEffect(() => {
    window.scroll(0, 0);
    const obj = { authenticate_key: "abcd123XYZ" };
    postRecord(APIGetSiteSetting, obj).then((res) => {
      if (res.data[0].response.status === "success") {
        setData(res.data[0].response.data);
      }
    });
  }, []);
  useEffect(() => {
    const obj = { authenticate_key: "abcd123XYZ" };
    postRecord(APIGetExampleData, obj).then((res) => {
      if (res.data[0].response.status === "success") {
        setExampleData(res.data[0].response.data);
      }
    });
  }, []);
  useEffect(() => {
    if (context.state.user) {
      const objusr = {
        authenticate_key: "abcd123XYZ",
        agent_id: JSON.parse(context.state.user).agentId,
      };
      postRecord(APIGetUserData, objusr).then((res) => {
        if (res.data[0].response.status === "success") {
          setCurrentUser(res.data[0].response.data.agent_profile);
        }
      });
    }
  }, [context.state.user]);
  useEffect(() => {
    if (context.state.user) {
      const objusr = {
        authenticate_key: "abcd123XYZ",
        broker_id: JSON.parse(context.state.user).user_id,
      };
      postRecord(APIGetBrokerDetails, objusr).then((res) => {
        setCurrentBroker(res.data[0].response.data.broker_profile);
      });
    }
  }, [context.state.user]);
  const handleScroll = () => {
    window.scrollTo(0, 0);
  };
  const handleLogout = () => {
    dispatch({
      type: "LOGOUT",
    });
  };
  const openBox = () => {
    if (!$("#mob_btn").hasClass("active")) {
      $("#mob_btn").addClass("active");
      $("#mobilemenu").addClass("active");
      return $("body").css("overflow", "hidden");
    } else {
      $("#mob_btn").removeClass("active");
      $("#mobilemenu").removeClass("active");
      return $("body").css("overflow", "auto");
    }
  };
  const metaCtx = MetaInfo();
  const [metaData, setMetaData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const objusr = {
        authenticate_key: "abcd123XYZ",
        pageId: 8,
      };
      const res = await postRecord(APIURL() + "get-metadata", objusr);

      setMetaData(res.data);
    };
    fetchData();
  }, []);
  useEffect(() => {
    metaCtx.setPageTitle(metaData.page);
    metaCtx.setMetaDesc(metaData.metaDesc);
    metaCtx.setMetaKw(metaData.metaKeyWords);
    metaCtx.setMetaTitle(metaData.metaTitle);
    metaCtx.setOgtitle(metaData.ogTitle);
    metaCtx.setOgDesc(metaData.ogDesc);
    metaCtx.setOgSiteName(metaData.ogSiteName);
    metaCtx.setTwitterCard(metaData.twitterCard);
    metaCtx.setTwitterSite(metaData.twitterSite);
    metaCtx.setTwitterTitle(metaData.twitterTitle);
    metaCtx.setTwitterDesc(metaData.twitterDesc);
  }, [metaData]);
  return (
    <div>
      <Title title="Example" />
      <section class="home_page">
        <div class="mobile_on mobile_slide">
          <div class="mob_head">
            <div class="hm_logo">
              <a href="#">
                <img src={Logo} alt="Logo" title="Logo" />
              </a>
            </div>

            <div id="mobilemenu">
              <div class="mobilemenu-wrapper">
                <div class="mobilemenu-trigger">
                  <button id="mob_btn" class="trigger" onClick={openBox}>
                    <span class="box">
                      <span class="bar top"></span>
                      <span class="bar middle"></span>
                      <span class="bar bottom"></span>
                    </span>
                  </button>
                </div>
                <div class="mobilemenu-view">
                  <div class="menu">
                    <ul>
                      <li>
                        <Link to={APIPath() + "login"}>Login</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent"}>Register</Link>
                      </li>
                      <li class="">
                        <Link to={APIPath()}>Home</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "features"}>Features</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent"}>Agents</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "broker"}>Brokers</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "association"}>Associations</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "preferred-vendors"}>
                          Preferred Vendors
                        </Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "about-us"}>About</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "example"}>Example</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "pricing"}>Pricing</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "faq"}>FAQ</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="spacer1px"></hr>
        <div class="home_page_banner inner_banner">
          {Object.keys(exampleData).length > 0 ? (
            <img src={exampleData.banner_section.image} alt="" title="" />
          ) : (
            <img src={banner} alt="" title="" />
          )}
          <div class="inner_banner_cont">
            <div class="inner_banner_cont_sec">
              <h2>
                {Object.keys(exampleData).length > 0 ? (
                  exampleData.banner_section.title
                ) : (
                  <Skeleton
                    variant="text"
                    width={250}
                    height={100}
                    style={{ background: "#bbbbbb", margin: "0 auto" }}
                  />
                )}
              </h2>
              <h5>
                {Object.keys(exampleData).length > 0 ? (
                  exampleData.banner_section.sub_title
                ) : (
                  <Skeleton
                    variant="text"
                    width={450}
                    height={80}
                    style={{ background: "#bbbbbb", margin: "0 auto" }}
                  />
                )}
              </h5>
            </div>
          </div>
          <div class="inner_page_breadcumb">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="inner_page_breadcumb_main">
                    <ul>
                      <li>
                        <Link to={APIPath()}>
                          <i class="fas fa-home"></i>Home
                        </Link>
                      </li>
                      <li>
                        <Link to={""}>Example</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="head_sec">
          <header class="desktop_sticky">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="head_main">
                    <div class="head_cont_left">
                      <ul>
                        <li>
                          <a href="mailto:support@VirtualTourCafe.com">
                            <i class="far fa-envelope"></i>
                            {Object.keys(data).length > 0 ? (
                              data.site_email
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={30}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </a>
                        </li>
                        <li>
                          <a href="tel:(877) 744-8285 or (925) 609-2408">
                            <i class="fas fa-phone-alt"></i>
                            {Object.keys(data).length > 0 ? (
                              data.phone_number
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={30}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="head_cont_right">
                      {context.state.isAuthenticated &&
                      JSON.parse(context.state.user).role == "broker" ? (
                        <ul>
                          {/* <li><Link to={APIPath() + "register"} class="register_btn"><i class="fas fa-edit"></i>Register</Link></li> */}
                          <li class="dashboard nav-item nav-profile dropdown dropdown-animate">
                            <a
                              href="#"
                              class="nav-link dropdown-toggle"
                              data-toggle="dropdown"
                              id="profileDropdown"
                              aria-expanded="false"
                            >
                              <div class="user_img">
                                <img src={user} alt="profile" />
                              </div>
                            </a>
                            <div
                              class="dropdown-menu dropdown-menu-right navbar-dropdown profile-top"
                              aria-labelledby="profileDropdown"
                              style={{ zIndex: "99" }}
                            >
                              <div class="profile-header d-flex align-items-center">
                                <div class="thumb-area">
                                  <img src={user} alt="profile" />
                                </div>
                                <div class="content-text">
                                  <h6>{currentBroker.name}</h6>
                                </div>
                              </div>
                              <Link
                                to={APIPath() + "broker-dashboard"}
                                class="dropdown-item"
                              >
                                <i class="fas fa-user profile-icon"></i>
                                Dashboard
                              </Link>
                              <a
                                href={APIPath() + "broker-setting"}
                                class="dropdown-item"
                              >
                                <i class="fas fa-cog profile-icon"></i>Settings
                              </a>
                              <Link
                                to={APIPath() + "broker-reports"}
                                class="dropdown-item"
                              >
                                <i class="fas fa-info-circle profile-icon"></i>
                                Support
                              </Link>
                              <Link
                                onClick={handleLogout}
                                to={APIPath()}
                                class="dropdown-item"
                              >
                                <i class="fas fa-sign-out-alt profile-icon"></i>
                                Sign Out
                              </Link>
                            </div>
                          </li>
                        </ul>
                      ) : context.state.isAuthenticated &&
                        JSON.parse(context.state.user).role == "agent" ? (
                        <ul>
                          {/* <li><Link to={APIPath() + "register"} class="register_btn"><i class="fas fa-edit"></i>Register</Link></li> */}
                          <li class="dashboard nav-item nav-profile dropdown dropdown-animate">
                            <a
                              href="#"
                              class="nav-link dropdown-toggle"
                              data-toggle="dropdown"
                              id="profileDropdown"
                              aria-expanded="false"
                            >
                              <div class="user_img">
                                <img
                                  src={currentUser && currentUser.profile_img}
                                  alt="profile"
                                />
                              </div>
                            </a>
                            <div
                              class="dropdown-menu dropdown-menu-right navbar-dropdown profile-top"
                              aria-labelledby="profileDropdown"
                              style={{ zIndex: "99" }}
                            >
                              <div class="profile-header d-flex align-items-center">
                                <div class="thumb-area">
                                  <img
                                    src={currentUser && currentUser.profile_img}
                                    alt="profile"
                                  />
                                </div>
                                <div class="content-text">
                                  <h6>{currentUser.name}</h6>
                                </div>
                              </div>
                              <Link
                                to={APIPath() + "agent-dashboard"}
                                class="dropdown-item"
                              >
                                <i class="fas fa-user profile-icon"></i>
                                Dashboard
                              </Link>
                              <a
                                href={APIPath() + "agent-setting"}
                                class="dropdown-item"
                              >
                                <i class="fas fa-cog profile-icon"></i>Settings
                              </a>
                              <Link
                                to={APIPath() + "agent-support"}
                                class="dropdown-item"
                              >
                                <i class="fas fa-info-circle profile-icon"></i>
                                Support
                              </Link>
                              <Link
                                onClick={handleLogout}
                                to={APIPath()}
                                class="dropdown-item"
                              >
                                <i class="fas fa-sign-out-alt profile-icon"></i>
                                Sign Out
                              </Link>
                            </div>
                          </li>
                        </ul>
                      ) : (
                        <ul>
                          <li>
                            <Link
                              to={APIPath() + "appointment"}
                              class="login_btn"
                            >
                              <i class="fal fa-book"></i>Schedule Your
                              Appointment
                            </Link>
                          </li>
                          <li>
                            <Link to={APIPath() + "login"} class="login_btn">
                              <i class="far fa-lock-alt"></i>Login
                            </Link>
                          </li>
                          <li>
                            <Link to={APIPath() + "agent"} class="register_btn">
                              <i class="fas fa-edit"></i>Register
                            </Link>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div class="head_menu_sec_new">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="head_sec_menu">
                    <div class="row">
                      <div class="col-lg-3 col-md-3">
                        <div class="vtc_logo">
                          <Link to={APIPath()}>
                            <img src={Logo} alt="Logo" title="Logo" />
                          </Link>
                        </div>
                      </div>
                      <div class="col-lg-9 col-md-9">
                        <div class="head_sec_menu_main">
                          <ul>
                            <li>
                              <Link to={APIPath()}>Home</Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "features"}>Features</Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "agent"}>Agents</Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "broker"}>Brokers</Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "association"}>
                                Associations
                              </Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "preferred-vendors"}>
                                Preferred Vendors
                              </Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "about-us"}>About</Link>
                            </li>
                            <li class="active">
                              <Link to={APIPath() + "example"}>Example</Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "pricing"}>Pricing</Link>
                            </li>
                            <li>
                              <Link to={APIPath() + "faq"}>FAQ</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="brokers_sec accociations_sec">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="features_sec_main">
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <div class="features_sec_right_2">
                      {Object.keys(exampleData).length > 0 ? (
                        <img
                          src={exampleData.banner_underneath_sec.image}
                          alt=""
                          title=""
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          width={400}
                          height={300}
                          style={{ background: "#bbbbbb", margin: "0 auto" }}
                        />
                      )}
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="features_sec_left">
                      <h4>
                        {Object.keys(exampleData).length > 0 ? (
                          exampleData.banner_underneath_sec.title
                        ) : (
                          <Skeleton
                            variant="text"
                            width={500}
                            height={80}
                            style={{ background: "#bbbbbb", margin: "0 auto" }}
                          />
                        )}
                      </h4>
                      <p>
                        {Object.keys(exampleData).length > 0 ? (
                          exampleData.banner_underneath_sec.sub_title
                        ) : (
                          <Skeleton
                            variant="text"
                            width={500}
                            height={180}
                            style={{ background: "#bbbbbb", margin: "0 auto" }}
                          />
                        )}
                      </p>
                      {Object.keys(exampleData).length > 0 ? (
                        <div
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html:
                              exampleData.banner_underneath_sec.description,
                          }}
                        ></div>
                      ) : (
                        <Skeleton
                          variant="text"
                          width={500}
                          height={200}
                          style={{ background: "#bbbbbb", margin: "0 auto" }}
                        />
                      )}
                      {/* <Link to={APIPath() + "contact-us"} class="need_pic qoute">Contact Us<i class="fas fa-arrow-right"></i></Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="example_projects" id="Photography">
        <div class="recent_projects_head">
          <h2>Photography & Videos</h2>
        </div>
        <div class="recent_projects_tabs">
          <div class="tab_img">
            <div class="row">
              {Object.keys(exampleData).length > 0 ? (
                exampleData.example_projectsData.example_1.map((res) => (
                  <div class="col-lg-4 col-md-4">
                    <div class="recent_projects_tabs_img">
                      <img src={res.image} alt="" title="" />
                      <div class="recent_projects_tabs_img_conts">
                        <a href={res.link} target="_blank">
                          <div class="recent_projects_tabs_img_conts_inner">
                            <span class="link_icn">
                              <i class="fas fa-link"></i>
                            </span>
                            <h4>{res.title}</h4>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section class="example_projects2" id="AriealDrone">
        <div class="recent_projects_head">
          <h2>Aerial Drone Photos & Video</h2>
        </div>
        <div class="recent_projects_tabs">
          <div class="tab_img">
            <div class="row">
              {Object.keys(exampleData).length > 0 ? (
                exampleData.example_projectsData.example_2.map((res) => (
                  <div class="col-lg-4 col-md-4">
                    <div class="recent_projects_tabs_img">
                      <img src={res.image} alt="" title="" />
                      <div class="recent_projects_tabs_img_conts">
                        <a href={res.link} target="_blank">
                          <div class="recent_projects_tabs_img_conts_inner">
                            <span class="link_icn">
                              <i class="fas fa-link"></i>
                            </span>
                            <h4>{res.title}</h4>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section class="example_projects2" id="Walkthrough">
        <div class="recent_projects_head">
          <h2>3D WalkThrough Tours Sell Houses Faster!</h2>
        </div>
        <div class="recent_projects_tabs">
          <div class="tab_img">
            <div class="row">
              {Object.keys(exampleData).length > 0 ? (
                exampleData.example_projectsData.example_3.map((res) => (
                  <div class="col-lg-4 col-md-4">
                    <div class="recent_projects_tabs_img">
                      <img src={res.image} alt="" title="" />
                      <div class="recent_projects_tabs_img_conts">
                        <a href={res.link} target="_blank">
                          <div class="recent_projects_tabs_img_conts_inner">
                            <span class="link_icn">
                              <i class="fas fa-link"></i>
                            </span>
                            <h4>{res.title}</h4>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section class="example_projects2">
        <div class="recent_projects_head">
          <h2>Virtual Staging</h2>
        </div>
        <div class="recent_projects_tabs">
          <div class="tab_img">
            <div class="row">
              {Object.keys(exampleData).length > 0 ? (
                exampleData.example_projectsData.example_4.map((res) => (
                  <div class="col-lg-4 col-md-4">
                    <div class="recent_projects_tabs_img">
                      <img src={res.image} alt="" title="" />
                      <div class="recent_projects_tabs_img_conts">
                        <a href={res.link} target="_blank">
                          <div class="recent_projects_tabs_img_conts_inner">
                            <span class="link_icn">
                              <i class="fas fa-link"></i>
                            </span>
                            <h4>{res.title}</h4>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                  <div class="col-lg-4 col-md-4" style={{ float: "left" }}>
                    <Skeleton
                      variant="text"
                      width={330}
                      height={280}
                      style={{ background: "#bbbbbb", margin: "0 auto" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <div class="ftr_get">
        <Footer1></Footer1>
        <Footer />
      </div>
      <a
        onClick={handleScroll}
        id="return-to-top"
        class="bounce"
        style={{ display: "block", cursor: "pointer" }}
      >
        <i class="fas fa-angle-double-up"></i>
      </a>
    </div>
  );
}
